import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import GridContainer from 'components/Grid/GridContainer.js';

import ComboGeneral from './NewCombo/ComboGeneral';
import ZoneCanal from '../Promotion/ZoneCanal';

import BusinessLines from '../Promotion/BusinessLines';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsGet } from 'services/WService';
import ComboProducts from './NewCombo/ComboProducts';

function NewCombo() {
  const { id } = useParams();
  const [promotion, setPromotion] = useState({});
  const [combos, setCombos] = useState([]);
  const [notify, showNotify] = useToasty();

  async function getPromotion() {
    let response = await wsGet('prom/promotion', id);
    if (response.success) {
      let { combos, ...promotion } = response.data;
      setPromotion(promotion);
      setCombos(combos);
    }
  }

  useEffect(() => {
    getPromotion();
  }, []);
  //NG
  return (
    <GridContainer>
      <Toasty action={notify} />

      <ComboGeneral
        isNew={id == 0 ? true : false}
        promotionInitial={promotion}
        reload={getPromotion}
        existSaleGroup={false} //estado de grupo-venta
        existBoniGroup={false} //estado de grupo-bonificación
        showNotify={showNotify}
      />
      {promotion.only_business_lines === 'Y' ? (
        <BusinessLines promotion={promotion} showNotify={showNotify} getPromotion={getPromotion} />
      ) : undefined}

      {id != 0 && !!promotion.id && promotion.description !== '' ? (
        <>
          <ComboProducts
            combos={combos}
            promotion={promotion}
            showNotify={showNotify}
            reload={getPromotion}
          />

          <ZoneCanal promotion={promotion} setCurrentRest={() => {}} showNotify={showNotify} />
        </>
      ) : (
        <div style={{ width: '100%' }}>
          <h3 style={{ textAlign: 'center' }}>Ingrese la información para continuar...</h3>
          <p style={{ textAlign: 'center' }}>
            Los campos Descripción y Proveedor son necesarios para una promoción.
          </p>
        </div>
      )}

      {/* {currentRest ? <Customer promotion={promotion} /> : undefined} */}
    </GridContainer>
  );
}

export default NewCombo;
